module.exports = __webpack_public_path__ + "img/sub.d6e10be8.png";